import { useEffect, useState } from "react"
import Wrapper from "./NoSubscription.styles"
import config from "../../Utility/ConfigUtility"

export const NoSubscription = () => {

    const [counter, setCounter] = useState(10)

    useEffect(() => {
        const timer = setInterval(_ => {
            if(counter) {
                setCounter(c => {
                    if(c !== 0){
                        return c - 1
                    } else {
                        window.location = config.msaUrl
                    }
                })
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [counter])

    return (
        <Wrapper>
            <h1>No Subscriptions</h1>
            <p>This will redirect back to Market-Sizing Assets in {counter} seconds.</p>
            <input className="primary" type="button" value="Back to MSA" onClick={e => {window.location = config.msaUrl}} />
        </Wrapper>
    )
}